module.exports = __webpack_public_path__ + "img/swiper_02.c624c6a7.jpg";